'use client';

import Link from 'next/link';

import { Button } from '@/components/ui/button';

export default function NotFound() {
	return (
		<section className='bg-app-background-color min-h-screen'>
			<div className='mx-auto max-w-screen-xl px-4 py-8 md:py-16 lg:px-6 lg:py-32'>
				<div className='mx-auto max-w-screen-sm text-center'>
					<h1 className='mb-4 text-7xl font-extrabold tracking-tight text-app-foreground-color  lg:text-9xl'>404</h1>
					<p className='mb-4 text-3xl font-bold tracking-tight text-app-foreground-color'>{'Đã có lỗi xảy ra'}</p>
					<p className='mb-4 text-lg font-light text-app-foreground-color'>Trang bạn đang tìm kiếm không tồn tại.</p>

					<Button className='bg-app-primary-color hover:bg-app-primary-color hover:opacity-90'>
						<Link href='/'>Trở về trang chủ</Link>
					</Button>
				</div>
			</div>
		</section>
	);
}
